/**
 * @generated SignedSource<<a4c1469e45f3bc1bc08535c67a326333>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleFooterArticle$data = {
  readonly sponsorType: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckArticleIsInSectionsArticle" | "helpersCheckIsStyleArticle" | "helpersGetArticleTypeArticle" | "morningStudioArticleFooterContent">;
  readonly " $fragmentType": "articleFooterArticle";
};
export type articleFooterArticle$key = {
  readonly " $data"?: articleFooterArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleFooterArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  }
],
v1 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SectionSegmentV2",
        "kind": "LinkedField",
        "name": "sectionsV2",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "value",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v0/*: any*/),
                "type": "Section",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v0/*: any*/),
                "type": "VideoSection",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Content",
    "abstractKey": "__isContent"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleFooterArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsStyleArticle",
      "selections": (v1/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersGetArticleTypeArticle",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArticleTypeSegment",
                  "kind": "LinkedField",
                  "name": "types",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ArticleType",
                      "kind": "LinkedField",
                      "name": "value",
                      "plural": true,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Article",
              "abstractKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioArticleFooterContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckArticleIsInSectionsArticle",
      "selections": (v1/*: any*/),
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "f0be1d5c2b29dfcc1072b42b00c3d8b0";

export default node;
